module.exports = __webpack_public_path__ + "static/media/wall-tuluu.bbf39922.jpg";